let config = {
   //quipHost: "https://quip-export-local.sentralos.workers.dev/?apiurl=https://platform.quip.com/1/",
   quipHost: "https://quip-export.sentralos.workers.dev/?apiurl=https://platform.quip.com/1/" // 100.000 per day, 1.000 per 10 minutes
}

export default config;
